import CalendarItemWithoutPatient from './CalendarItemWithoutPatient';

export default {
    ...CalendarItemWithoutPatient,
    name: CalendarItemWithoutPatient.name + '_resource',
};
